export default {
  paused: 'Os pagamentos online estão pausados devido a problemas de verificação KYC.',
  deadline_warning: 'A verificação KYC é necessária, caso contrário os pagamentos online serão pausados em {{date}}.',
  complete_verification: 'Concluir verificação',
  partner: {
    action_needed:
      'O seu fornecedor de pagamentos precisa de mais uma coisa antes de este restaurante poder aceitar pagamentos online.',
    hosted_incomplete: 'Ainda não concluiu a configuração dos pagamentos online com o seu fornecedor de pagamentos.',
    link_expired: 'O seu link para concluir a configuração dos pagamentos online expirou. Obtenha um novo e continue.',
    open_error: 'Não foi possível contactar o fornecedor de pagamentos. Tente novamente dentro de alguns minutos.',
    hosted_not_started: 'Os pagamentos online ainda não estão configurados com o seu fornecedor de pagamentos.',
    business_details_missing: 'Adicione os dados da sua empresa para começar a receber pagamentos online.',
    continue: 'Continuar',
  },
};
